/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfIChingImportResultDto } from '../../models/platform-api-result-of-i-ching-import-result-dto';
import { PlatformImportIChingConsultations } from '../../models/platform-import-i-ching-consultations';

export interface PostIchingConsultationsActionImport$Params {
      body: PlatformImportIChingConsultations
}

export function postIchingConsultationsActionImport(http: HttpClient, rootUrl: string, params: PostIchingConsultationsActionImport$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIChingImportResultDto>> {
  const rb = new RequestBuilder(rootUrl, postIchingConsultationsActionImport.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfIChingImportResultDto>;
    })
  );
}

postIchingConsultationsActionImport.PATH = '/api/iching/consultations/action/import';
